const DATE_FMT_MMDDYYYY = /^(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])\/(19\d{2}|[2-9]\d{3})$/;
const transactionTypeMap = {
  'purchase': 'Purchase',
  'reversal': 'Return',
  'ccpayment': 'Credit Card Payment',
  'checkpayment': 'Check Payment',
  'cashpayment': 'Cash Payment',
  'balanceAdjustment': 'Balance Adjustment',
  'checkrefund': 'Refund (check)',
  'cashrefund': 'Refund (cash)',
  'ccrefund': 'Refund (Credit Card)',
  'accountTypeAdjustment': 'Account Adjustment'
}

export { DATE_FMT_MMDDYYYY, transactionTypeMap }